// Shop actions
export const UPDATE_ZODIAC = 'UPDATE_ZODIAC';

// Blog actions
export const RECEIVE_ENTRIES = 'RECEIVE_ENTRIES';

// Error actions
export const RECEIVE_ERROR = 'RECEIVE_ERROR';
